import { Injectable } from '@angular/core';
import { SHARED_MASTER_DATA_PAYOR_MASTER_LOOKUP_TYPES } from '@libs/shared/domain/master-data/payor-master-lookup/shared-master-data-payor-master-lookup.type';
import { SourceFilterOptionsLoader, toOptions } from '@shared/dataview/options/filter-options.registry';
import { SelectListItem } from '@shared/models/select-list-item';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PayorPlanTypesOptionsLoader extends SourceFilterOptionsLoader {
  readonly source = 'payorPlanTypes';

  load(): Observable<SelectListItem[]> {
    return of(toOptions([...SHARED_MASTER_DATA_PAYOR_MASTER_LOOKUP_TYPES].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))));
  }
}
